import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Tag } from 'antd';

import { getIssueStatusMeta } from '../issue-status';

import useDropdownItems from './use-dropdown-items';

/**
 * "Sorun Var/Yok" hücresi: mevcut durumu Tag olarak gösterir, tıklanınca
 * durum değiştirme dropdown'ını açar. Sütun başlığındaki filtre ikonu ayrı çalışır.
 * @param {Object} props
 * @param {string} props.id - İlişki öğesinin ID'si
 * @param {string} props.hasIssue - Sorun durumu enum'u (issue | no_issue | in_review)
 */
function IssueStatusDropdown({ id, hasIssue }) {
  const dropdownItems = useDropdownItems({ id, hasIssue });
  const { label, color } = getIssueStatusMeta(hasIssue);

  return (
    <Dropdown
      menu={{ items: dropdownItems }}
      trigger={['click']}
    >
      <div
        className="gx-d-flex gx-align-items-center"
        style={{ cursor: 'pointer', gap: 4 }}
        title="Sorun durumunu değiştir"
      >
        {/* Global .ant-tag kuralı 8px alt margin veriyor; margin kutusu ortalandığı için sıfırlanmazsa Tag ok ikonuna göre yukarı kayar */}
        <Tag
          color={color}
          style={{ margin: 0 }}
        >
          {label}
        </Tag>
        <DownOutlined style={{ fontSize: 10 }} />
      </div>
    </Dropdown>
  );
}

export default IssueStatusDropdown;
